// Components, atoms, molecules, organisms
import AddBankDetailsContainer from './AddBankDetailsContainer';

export { AddBankDetailsContainer };

export default AddBankDetailsContainer;